import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import classNames from 'classnames';
const ReminderCount = ({ count }) => (_jsx("span", Object.assign({ className: classNames('reminder-count', { 'reminder-count-zero': !count }) }, { children: count })));
export default ReminderCount;
